/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React from "react";
import Typography from "../../../../components/common/new/Typography/Typography";
import styles from "./CardWithFooter.styles";
import Button from "../../../../components/common/Button";
import useUserConfig from "../../../../hooks/useUserConfig";
import { PERMISSIONS } from "../../../../contants";

function CardWithFooter({
  children,
  title,
  onViewMoreHandler,
  disableViewMore,
  tableType,
  footerText = "View More",
  hideFooter = false,
  minHeight = 0,
  mainContainerStyle = {},
  customStyles,
  icon,
  subTitle,
  dropDown,
  action,
  showButton = false,
  editSub = false,
  showExamButton = false,
}) {
  const hasPermission = useUserConfig();

  return (
    <Box style={{ ...styles.card, ...customStyles }}>
      <Box style={styles.title}>
        <Typography weight={600} style={{ color: "#000", fontSize: "18px" }}>
          {title}
        </Typography>

        <Box
          style={{
            marginLeft: "auto",
          }}
        >
          {icon}
        </Box>
      </Box>
      {dropDown && <Box style={styles.dropDown}>{dropDown}</Box>}
      <Box style={styles.title}>
        <Typography
          component="p"
          weight={600}
          style={{ color: "#607E9F", fontSize: "14px" }}
        >
          {subTitle}
        </Typography>
      </Box>
      <Box
        minHeight={minHeight}
        style={{ ...styles.main, ...mainContainerStyle }}
      >
        {children}
      </Box>
      {showButton && hasPermission(PERMISSIONS.GOHONZON_DIRECT_ENTRY) && (
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <Button
            label="Add"
            onClick={action}
            style={{ width: "90px", height: "24px" }}
          />
        </Box>
      )}
      {editSub && hasPermission(PERMISSIONS.ADD_SUBSCRIPTION) && (
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <Button
            label="Edit"
            onClick={action}
            style={{ width: "90px", height: "24px" }}
          />
        </Box>
      )}
      {showExamButton && hasPermission(PERMISSIONS.EXAM_DIRECT_ENTRY) && (
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <Button
            label="Add"
            onClick={action}
            style={{ width: "90px", height: "24px" }}
          />
        </Box>
      )}
      {!hideFooter && (
        <Box style={styles.footer}>
          {!disableViewMore && (
            <Typography
              onClick={() => onViewMoreHandler(tableType, title, subTitle)}
              pointer
              decoration="underline"
              variant="mini"
              weight={500}
              color="#00ADF8"
            >
              {footerText}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
}

export default CardWithFooter;
